import type { FC, ReactNode } from 'react'

import type { WhiteLabel } from '@skytech/types'
import { twJoin, twMerge } from 'tailwind-merge'

export type BadgeType = 'neutral' | 'positive' | 'negative'
export type BadgeSize = 'small' | 'regular'

export const Badge: FC<{
  type: BadgeType
  children?: ReactNode
  className?: string
  whiteLabel?: WhiteLabel
  size?: BadgeSize
}> = ({ whiteLabel, className, children, type = 'neutral', size = 'regular' }) => {
  // todo: replace with the org from url when ready
  const storedWhiteLabel = localStorage.getItem('org') as WhiteLabel
  const wl = whiteLabel || storedWhiteLabel

  return (
    <div
      className={twMerge(
        'w-fit rounded-2xl text-base',
        statusColorClasses[type],
        sizeClasses[size],
        wl === 'telia' && 'font-telia',
        wl === 'telia' && type === 'positive' && 'bg-telia-success text-white',
        className
      )}
    >
      <div className={twJoin('px-2 text-center')}>{children}</div>
    </div>
  )
}

const statusColorClasses: Record<BadgeType, string> = {
  negative: 'bg-red-100 text-red-600',
  positive: 'bg-teal-100 text-green-800',
  neutral: 'bg-amber-100 text-yellow-600',
}

const sizeClasses: Partial<Record<BadgeSize, string>> = {
  small: 'font-[0.8rem]',
}
